import { css } from 'styled-components';
import WavyPatternBlack from 'assets/wavy_pattern_black.png';
import WavyPatternWhite from 'assets/wavy_pattern_white.png';

export const UserSummaryEventStyles = css`
  .b-sch-event-wrap.user_allocation_summary {
    height: 48px;
    top: -12px;

    .b-sch-event {
      border-radius: 0px;
    }
    &.over-allocated {
      .b-sch-event {
        background-color: var(--red-90);
        border-color: var(--red-90);
        &.soft {
          &::after {
            content: '';
            position: absolute;
            top: 4px;
            background-image: url(${WavyPatternWhite});
            background-size: contain;
            height: calc(100% - 4px);
            width: max(100%, 60px);
            opacity: 15%;
          }
        }
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--red-10) !important;
        }
      }
    }
    &.mostly-allocated {
      .b-sch-event {
        background-color: var(--blue-80);
        border-color: var(--blue-80);
        &.soft {
          &::after {
            content: '';
            position: absolute;
            background-image: url(${WavyPatternWhite});
            background-size: contain;
            height: 100%;
            width: max(100%, 60px);
            opacity: 15%;
          }
        }
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--blue-10) !important;
        }
      }
    }
    &.moderately-allocated {
      .b-sch-event {
        background-color: var(--blue-50);
        border-color: var(--blue-50);
        &.soft {
          &::after {
            content: '';
            position: absolute;
            background-image: url(${WavyPatternWhite});
            background-size: contain;
            height: 100%;
            width: max(100%, 60px);
            opacity: 12%;
          }
        }
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--blue-90) !important;
        }
      }
    }
    &.mildly-allocated {
      .b-sch-event {
        background-color: var(--blue-20);
        border-color: var(--blue-20);
        &.soft {
          &::after {
            content: '';
            position: absolute;
            background-image: url(${WavyPatternBlack});
            background-size: contain;
            height: 100%;
            width: max(100%, 60px);
            opacity: 9%;
          }
        }
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--blue-80) !important;
        }
      }
    }
    &.sparsely-allocated {
      .b-sch-event {
        background-color: var(--green-10);
        border-color: var(--green-20);
        &.soft {
          &::after {
            content: '';
            position: absolute;
            background-image: url(${WavyPatternBlack});
            background-size: contain;
            height: 100%;
            width: max(100%, 60px);
            opacity: 9%;
          }
        }
        &.b-sch-event-selected .b-sch-event-content .content,
        .content {
          color: var(--green-80) !important;
        }
      }
    }
    .b-sch-event-content,
    &.b-sch-event-selected .b-sch-event-content {
      width: 100%;
      .content {
        width: unset;
        font-weight: var(--font-weight-bold) !important;
        flex-grow: 1;
      }
      .time-off-icon {
        margin-right: var(--spacing-03) !important;
      }
    }
  }
  .availability-filter-applied
    .b-sch-event-wrap.user_allocation_summary:not(.highlight) {
    opacity: 0.1;
  }
`;
